module.exports = __webpack_public_path__ + "media/assets/icons/back-white@3x-f655039aa7e199e0888be95e62f45f3f.png";